/**
 * @module app.shared
 */

import { autoinject } from 'aurelia-framework';
import { addDelegatedEventListener, removeDelegatedEventListener } from 'app/shared/lib/listen-events';
import { getKey, Key } from 'app/shared/lib/keys';
import { CustomAttributeBase } from 'app/shared/attributes/abstracts/custom-attribute-base';
import { SetFocusEvent } from 'app/shared/lib/events';
import { EventAggregator } from 'aurelia-event-aggregator';
import { AppLogger } from 'app/shared/lib/logging/app-logger';

const ListItemSelector = {
    PreviousItem: ':scope > :is(ul,ol) > li:has(+ li:focus)',
    NextItem: ':scope > :is(ul,ol) > li:focus + li',
    FirstItem: ':scope > :is(ul,ol) > li:first-child',
    LastItem: ':scope > :is(ul,ol) > li:last-child',
};

@autoinject()
export class EssSelectableListboxCustomAttribute extends CustomAttributeBase {

    constructor(element: Element, protected readonly logger: AppLogger, private readonly events: EventAggregator) {
        super(element, logger);
    }

    protected handleKeydown = (event: KeyboardEvent) => {
        let listItemQuery = null;
        switch(getKey(event)) {
            // basic directional menu navigation
            case Key.Up:
                listItemQuery = ListItemSelector.PreviousItem;
                break;
            case Key.Down:
                listItemQuery = ListItemSelector.NextItem;
                break;
            // set focus to first element in current sub-menu
            case Key.Home:
                listItemQuery = ListItemSelector.FirstItem;
                break;
            // set focus to last element in current sub-menu
            case Key.End:
                listItemQuery = ListItemSelector.LastItem;
                break;
            default:
                return true;
        }

        // prevent the browser from scrolling the page when using arrow keys
        event.preventDefault();

        // if one of the handled keys is selected, focus the proper list element
        if(!!listItemQuery) {
            const selectedListItem = this.element.querySelector<HTMLElement>(listItemQuery);
            if(!!selectedListItem) this.events.publish(new SetFocusEvent(selectedListItem));
        }

        return false;
    };

    protected attached() {
        addDelegatedEventListener(this.element, 'keydown', this.handleKeydown);
    }

    protected detached() {
        removeDelegatedEventListener(this.element, 'keydown', this.handleKeydown);
    }
}
